import React from 'react';
import { Box, SimpleGrid } from '@chakra-ui/react';
import { CustomText } from '../atoms';
import { SectionIcons } from '../../stateManagement/SettingsContext';
import { SectionData } from '../../interfaces';
import { CategoriesIcon } from '../atoms/CategoriesIcon';
import { SectionCardPreview } from '../molecules/SectionCardPreview';

interface SectionGridProps {
  sections?: SectionData[] | null;
  sectionIcons?: SectionIcons[];
  textColor?: string;
  sectionBgColor?: string;
  sectionIconsTranslations?: SectionIcons[];
  sectionsHeading: string;
  sectionHelperText: string;
  sectionCardTextColor: string;
  primaryAccentColor?: string;
  secondaryAccentColor?: string;
  categoriesHeadingTextColor?: string;
  onClickMore: (title: string) => void;
  onClickFaq: (id: string) => void;
}

export const SectionGridPreview: React.FC<SectionGridProps> = ({
  sections,
  sectionIcons,
  textColor,
  sectionBgColor = '#ffffff',
  sectionIconsTranslations,
  sectionsHeading,
  sectionHelperText,
  sectionCardTextColor,
  primaryAccentColor,
  secondaryAccentColor,
  categoriesHeadingTextColor,
  onClickMore,
  onClickFaq,
}) => {
  const translatedSectionIcons = sectionIcons?.map(item => {
    const sectionIconsTranslation = sectionIconsTranslations?.find(t => t.id === item.id);
    return {
      ...item, // Keep all properties from `items`
      name: sectionIconsTranslation?.name ?? item.name, // Override `title` if translation exists
    };
  });
  return (
    <>
      <CustomText
        variant="h1"
        fontSize={{ base: '2xl', md: '3xl' }} // Adjust font size for mobile
        fontWeight="bold"
        color={textColor}
      >
        <Box display="inline-flex" alignItems="center" gap="2">
          <CategoriesIcon color={primaryAccentColor} />
          {sectionsHeading}
        </Box>
      </CustomText>

      <Box height="3px" width="60px" backgroundColor={secondaryAccentColor} />
      <Box height="1px" width="100%" backgroundColor={secondaryAccentColor} mb="6" />
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing="6" mt="4vh">
        {sections?.map(section => {
          // Find the corresponding icon from sectionIcons
          const matchingIcon = translatedSectionIcons?.find(icon => icon.id === section.section_id);
          const formattedSectionTitle = `${section.section_name.toLowerCase().replace(/\s+/g, '-')}`;

          return (
            <SectionCardPreview
              key={section.section_id}
              textColor={sectionCardTextColor}
              bgColor={sectionBgColor}
              sectionName={section.section_name}
              faqs={section.faq_data}
              icon={matchingIcon?.icon || ''} // Pass the icon or an empty string as a fallback
              onClickMore={() => onClickMore(formattedSectionTitle)}
              onClickFaq={onClickFaq}
              sectionHelperText={sectionHelperText}
              helperTextColor={textColor}
              primaryAccentColor={primaryAccentColor}
              secondaryAccentColor={secondaryAccentColor}
              categoriesHeadingTextColor={categoriesHeadingTextColor}
            />
          );
        })}
      </SimpleGrid>
    </>
  );
};
